import {
  type AdServer,
  type DeviceType,
  type FinnLegendarySubVertical,
  type FinnLegendaryVertical,
  type GamPlacementDataStatus,
  type PageType,
  type PlacementId,
  type PlacementStatus,
  type SubVertical,
  type Vertical
} from './types/index.js';

export type PlacementStatusMetric = {
  placementId: PlacementId;
  adServer?: AdServer | undefined;
  statuses: Array<PlacementStatus | GamPlacementDataStatus>;
};

export type PlacementStatusMetricsBody = {
  deviceType: DeviceType | 'unknown';
  pageType: PageType | 'unknown';
  vertical: Vertical | FinnLegendaryVertical | 'unknown';
  subvertical: SubVertical | FinnLegendarySubVertical | 'unknown';
  adServer: AdServer | 'unknown';
  placementStatuses: Array<PlacementStatusMetric>;
};

export type ErrorMetricsBody = {
  deviceType: DeviceType | 'unknown';
  pageType: PageType | 'unknown';
  vertical: Vertical | FinnLegendaryVertical | 'unknown';
  subvertical: SubVertical | FinnLegendarySubVertical | 'unknown';
  errorMessage: string;
  logSessionId: string;
};
